import { PropsWithChildren } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';

import { JiraOverlayTemplate } from '@/components/signup/layouts/product-overlay-template.tsx';

export const JiraOverlayShim = ({ children }: PropsWithChildren) => {
	return (
		<JiraOverlayTemplate size="lg">
			<div css={jiraOverlayShimCss}>{children}</div>
		</JiraOverlayTemplate>
	);
};

const jiraOverlayShimCss = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	['& > div']: {
		paddingBlockStart: 0,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		['> div:first-of-type']: {
			[media.above.sm]: {
				paddingInlineStart: 0,
				paddingBlock: 0,
			},
		},
	},
});
